import HamburgerMenu from 'components/hamburgerMenu/HamburgerMenu';
import useTranslate from 'hooks/useTranslate';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom'
import auth from 'utils/Auth';

const Navbar2 = ({logoPath}) => {
    const location = useLocation()
    const {t} = useTranslate()
    const {currentStage} = useSelector(state => state.general)
    const [isHaveToken, setIsHaveToken] =useState(true)
    const navigate = useNavigate()
    const handleNavbar = (text) => {
	const parameters = auth.getUserChoises();

        if(text == "onlyRedirect"){
            if (isHaveToken && (parameters?.deliveryType &&
                parameters?.neighbourhoodId &&
                parameters?.restaurantId &&
                (parameters?.deliveryType == 1 || parameters?.regionId))) {
                navigate('/')
            }
        }else{
            auth.clearStorage()
            navigate('/')
        }
    }
    useEffect(() => {
        setIsHaveToken( (auth.isHaveToken() && !auth.isGuest()) ? true : false)
    },[currentStage])

    return (
        <div className={`navbar ${location.pathname == "/" ? "navbarAbsolute" : "navbarRelative"}`}>
            <img onClick={() => handleNavbar("onlyRedirect")} src={logoPath} alt="" />
            {
                !isHaveToken ? <button onClick={() => handleNavbar("redirect")} className='navbar-cancel' >
                {t('logout')}
            </button> : <HamburgerMenu/>
            }

        </div>
    )
}

export default Navbar2